import { render, staticRenderFns } from "./FraudTransactionsContainer.vue?vue&type=template&id=a2b0461a&"
import script from "./FraudTransactionsContainer.vue?vue&type=script&lang=ts&"
export * from "./FraudTransactionsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports